import { useState, useEffect } from 'react';
import { isLoggedIn } from '../utils/session';

/**
 * Tracks PutOn session auth so UI updates when login completes or session is cleared.
 */
export function useAuth() {
  const [loggedIn, setLoggedIn] = useState(() => isLoggedIn());

  useEffect(() => {
    const sync = () => setLoggedIn(isLoggedIn());
    window.addEventListener('puton-auth-changed', sync);
    const onVis = () => {
      if (document.visibilityState === 'visible') sync();
    };
    document.addEventListener('visibilitychange', onVis);
    window.addEventListener('focus', sync);
    return () => {
      window.removeEventListener('puton-auth-changed', sync);
      document.removeEventListener('visibilitychange', onVis);
      window.removeEventListener('focus', sync);
    };
  }, []);

  return loggedIn;
}
